(function ($, window, document, undefined) {
    var defaultOptions = {
        popupId: "errorModal",
    }

    $.fn.popupError = function (errorText, customOptions) {

        var options = $.extend({}, defaultOptions, customOptions);

        var popupHtml =
            '<div class="modal fade" id="'+options.popupId+'" tabindex="-1" role="dialog">'+
                '<div class="modal-dialog">'+
                    '<div class="modal-content">'+
                        '<div class="modal-header bg-danger">'+
                            '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
                                '<span aria-hidden="true">&times;</span>' +
                            '</button>'+
                            '<h4 class="modal-title text-danger">Error</h4>'+
                        '</div>'+
                        '<div class="modal-body"></div>'+
                        '<div class="modal-footer">'+
                            '<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>'+
                        '</div>'+
                    '</div>'+
                '</div>'+
            '</div>';

        // Insert the popup
        $('body').append(popupHtml);

        // Replace any thing that is typically brought through from json in the errorText
        var errorText = errorText.replace('"', '').replace('"', '').replace('\\/', '/');

        var errorModal = $('#'+options.popupId);

        // Call it via the bootstrap Modal plugin
        errorModal.modal();
        errorModal.find('.modal-body').text(errorText);
    };


})(jQuery, this, this.document);
